import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import {refreshTokens} from "../services/authService";

// Typ für die Daten, die die API zurückgibt (Beispiel)
interface WeatherData {
    date: string;
    temperatureC: number;
    summary: string;
}

const DashboardPage: React.FC = () => {
    const { user, logout } = useAuth();
    const [data, setData] = useState<WeatherData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Der Axios Interceptor fügt automatisch den Token hinzu!
                const response = await api.get<WeatherData[]>('/api/weatherforecast');
                setData(response.data);
            } catch (err) {
                setError('Daten konnten nicht geladen werden.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        void fetchData();
    }, []);

    if (loading) return <div>Lade Daten...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div style={{ padding: '20px' }}>
            <h1>Dashboard (Geschützt)</h1>
            <p>Willkommen, {user?.name} ({user?.id})! Hier sehen Sie geschützte Daten:</p>

            <ul>
                {data.map((item, index) => (
                    <li key={index}>
                        {item.date}: {item.temperatureC}°C - {item.summary}
                    </li>
                ))}
            </ul>

            <button onClick={logout} style={{ marginTop: '20px' }}>
                Logout
            </button>
            <button onClick={refreshTokens} style={{ marginTop: '20px' }}>
                Forece Refresh
            </button>
        </div>
    );
};

export default DashboardPage;